import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import {
    Route, Switch,
} from 'react-router-dom';

import urls from '../../app/urls';
import { PageNotFound } from '../../youwell-common/components';

import PreviewTask from './PreviewTask';
import LoadPreviewTask from './components/LoadPreviewTask';
import Layout from '../outside/components/Layout';
import { InternalLinkLoader } from '../../common/components';
import { parseInternalLink } from '../../youwell-common/taskContentUtils';

class Index extends React.Component {
    getLinkUrl = (link) => {
        const { taskOrModuleId, hash } = parseInternalLink(link);
        return `${urls.preview.home}/${taskOrModuleId}${hash}`;
    }

    render() {
        return (
            <Layout
                headerProps={{
                    hideHeaderLinks: true,
                    headerPageTitle: this.props.translate('preview.title'),
                }}
                fullPage
            >
                <Route path={`${urls.preview.home}/:taskId/:version?`} component={LoadPreviewTask} />

                <InternalLinkLoader linkUrlFunction={this.getLinkUrl} />

                <Switch>
                    <Route path={`${urls.preview.home}/:taskId`} component={PreviewTask} />
                    <Route component={PageNotFound} />
                </Switch>
            </Layout>
        );
    }
}

Index.propTypes = {
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(Index);
